import { EQuestionCodes, EStepCodes } from '../../../types/requestForm';
export var COMPLAINT_FROM_OWNER_PROPERTY_STEP = {
  code: EStepCodes.ComplaintFromOwnerProperty,
  question: {
    code: EQuestionCodes.ComplaintFromOwnerProperty,
    title: 'Жалоба от собственника объекта',
    fields: [],
    actions: []
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};